import * as types from './types';

export const toggleDiagChart = showDiagChart => ({
  type: types.TOGGLE_DIAG_CHART,
  showDiagChart,
});

export const pushDrilldownFilter = (name, rule, presetFid = null) => ({
  type: types.PUSH_DRILLDOWN_FILTER,
  name,
  rule,
  presetFid,
});

export const pushMultiDrilldownFilter = (rules) => ({
  type: types.PUSH_MULTI_DRILLDOWN_FILTER,
  rules,
});

export const addDimensionToDrawer = (dimensionName, filterRule) => ({
  type: types.ADD_DIMENSION_TO_DRAWER,
  dimensionName,
  filterRule,
});

export const toggleDimensionInCompareDrawer = (
  dimensionName,
  filterRule,
  dimensionDataObj,
) => ({
  type: types.TOGGLE_DIMENSION_IN_COMPARE_DRAWER,
  dimensionName,
  filterRule,
  dimensionDataObj,
});

export const selectMultipleDimensionInCompareDrawer = (
  dimensionName,
  appliedRules,
  dimensionList,
  dimensionData,
  savedFiltersCount,
) => ({
  type: types.SELECT_MULTIPLE_DIMENSION_IN_COMPARE_DRAWER,
  dimensionName,
  appliedRules,
  dimensionList,
  dimensionData,
  savedFiltersCount,
});

export const unSelectMultipleDimensionInCompareDrawer = (
  dimensionName,
  appliedRules,
  dimensionList,
  dimensionData,
) => ({
  type: types.UNSELECT_MULTIPLE_DIMENSION_IN_COMPARE_DRAWER,
  dimensionName,
  appliedRules,
  dimensionList,
  dimensionData,
});
